(function () {
  "use strict";

  angular.module("sempraWebapp").controller("LoginController", LoginController);

  /** @ngInject */
  function LoginController(
    $state,
    locales,
    LoginViewModel,
    sessionData,
    userActions,
    version,
    applicationStore,
    userRolesEnum,
    checkUserRole,
    helperService,
    dispatcher,
    ActionTypesEnum,
    $translate
  ) {
    var vm = this;

    vm.login = new LoginViewModel();

    vm.version = version;
    vm.hasError = false;
    vm.buttonTitle = $translate.instant('LOGIN');
    vm.errorDescription = "";
    vm.inputType = "password";

    vm.doLogin = function () {
      vm.buttonTitle = $translate.instant('LOADING_DATA');

      userActions.signIn(vm.login.email.toLowerCase(), vm.login.password).then(
        function (userInfo) {
          checkUserRole.setCurrentRoles(userInfo.roles);
          helperService.setCurrentUserId(userInfo.user.id);
          helperService.setUserDataToLocalStorageOnLogIn(userInfo, vm.login.selectedLanguageId);

          if (checkUserRole.userRoleExist()) {
            $state.go("app.dashboardTechnology");
          } else {
            if (checkUserRole.hasAcceptNewTerms(userInfo.roles)) {
              $state.go("app.termsAndService", { marker: 'ready2wash-terms-of-service' });
            } else {
              sessionData.clearAll();
              vm.login.hasErrors = true;
              vm.login.errorMessage = $translate.instant("ERROR_LOGIN_ROLE");
            }
          }
        },
        function () {
          vm.login.hasErrors = true;
          vm.login.errorMessage = $translate.instant("ERROR_LOGIN");
          vm.buttonTitle = $translate.instant('LOGIN');
        }
      );
    };

    vm.showPassword = function() {
      vm.inputType = vm.inputType === "text" ? "password" : "text";
    }

    vm.onSelectedLanguageChange = function () {
      setLanguage(vm.login.selectedLanguageId);
      localStorage.setItem("language", vm.login.selectedLanguageId);
      vm.buttonTitle = $translate.instant('LOGIN');
    };

    // vm.goTermsAndServices = function (marker) {
    //   $state.go("app.termsAndService", { marker: marker });
    // };

    init();

    function init() {
      applicationStore.on(
        applicationStore.events.ERROR_STATE_CHANGE,
        showHideError
      );

      var session = sessionData.getAll();
      if (session[sessionData.Keys.LANGUAGE_KEY]) {
        vm.login.selectedLanguageId = session[sessionData.Keys.LANGUAGE_KEY];
      }
      if (session[sessionData.Keys.USERNAME_KEY]) {
        vm.login.email = session[sessionData.Keys.USERNAME_KEY];
      }
      setLanguage(vm.login.selectedLanguageId);

      if (session[sessionData.Keys.ACCESS_TOKEN_KEY]) {
        $state.go("app.dashboardTechnology");
      }
    }

    function showHideError(_hasError, _errMsgName, _errMsgDescription) {
      vm.hasError = _hasError;
      vm.errorDescription = _errMsgDescription;
    }

    function setLanguage(language) {
      locales.setLanguage(language);
    }
  }
})();
